function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Austin Community College");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.9,66.6c-1.9,4.6-3.8,9.1-5.7,13.7c-0.4,0.8-0.6,1.7-0.8,2.6c-0.4,2,0,3.8,1.6,5.3c0.2,0.2,0.6,0.4,0.6,0.9c-4.6,0-9.2,0-14.1,0c4.4-3.9,5.8-9,7.8-13.9c5.2-12.9,10.3-25.9,15.4-38.9c0.1-0.3,0.2-0.5,0.3-0.8c0.8-2.5,1.4-5-1.6-7.2c5,0,9.5,0,14.1,0c0.5,0.4,0.6,1.1,0.8,1.7c6,15.9,12,31.8,18,47.7c1.5,4.1,3.6,7.9,7,10.7c0.1,0.1,0.3,0.2,0.2,0.6c-5.6,0-11.2,0-17,0c0.2-0.8,0.9-1.2,1.3-1.7c0.9-1.1,1.3-2.3,0.8-3.8c-1.3-4-2.9-7.9-4.4-11.8c-0.6-1.7-1.3-3.4-2-5.2C133.8,66.6,126.4,66.6,118.9,66.6z M138.8,60.1c-2.8-7.6-5.5-15-8.2-22.5c-0.1,0-0.3,0-0.4,0c-3,7.4-5.9,14.9-9,22.5C127.3,60.1,132.9,60.1,138.8,60.1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M205.1,29.2c0,3.2,0,6.4,0,9.8c-0.9-0.4-1.6-0.7-2.3-1c-3.9-1.9-7.9-3.1-12.3-3.2c-11.5-0.3-20,6.6-22.1,16.7c-1.3,6.4-0.9,12.8,1.9,18.9c4.1,8.9,13.2,13.5,22.8,12.5c5.5-0.6,10.4-2.7,15.2-5.2c0.5-0.3,0.9-0.7,1.8-0.6c-1.4,3.6-2.8,7.1-4.3,10.7c-3.1,1.2-6.3,2-9.5,2.5c-8.2,1.2-16.1,0-23.5-3.9c-8.7-4.6-13.8-12-15.3-21.6c-2.1-13,2.4-23.6,12.8-31.6c4.9-3.8,10.7-5.7,16.9-6.2c5.5-0.5,10.9,0.2,16.2,1.7C204,28.7,204.5,28.8,205.1,29.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M259.3,29.2c0,3.2,0,6.4,0,9.8c-0.9-0.4-1.6-0.7-2.3-1c-3.9-1.9-7.9-3.1-12.3-3.2c-11.5-0.3-20,6.6-22.1,16.7c-1.3,6.4-0.9,12.8,1.9,18.9c4.1,8.9,13.2,13.5,22.8,12.5c5.5-0.6,10.4-2.7,15.2-5.2c0.5-0.3,0.9-0.7,1.8-0.6c-1.4,3.6-2.8,7.1-4.3,10.7c-3.1,1.2-6.3,2-9.5,2.5c-8.2,1.2-16.1,0-23.5-3.9c-8.7-4.6-13.8-12-15.3-21.6c-2.1-13,2.4-23.6,12.8-31.6c4.9-3.8,10.7-5.7,16.9-6.2c5.5-0.5,10.9,0.2,16.2,1.7C258.2,28.7,258.7,28.8,259.3,29.2z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 288 100",
    width: 80
  }, props), _ref, React.createElement("g", {
    className: "star"
  }, React.createElement("path", {
    style: {
      "fill": "#009B7C"
    },
    d: "M52.8,32.6L56,8.1l19.3,18.8"
  }), React.createElement("path", {
    style: {
      "fill": "#007AC2"
    },
    d: "M57.4,59.8l3.5-20.6l61.5-15.4L75.3,55.5l20.6,36.1"
  }), React.createElement("path", {
    style: {
      "fill": "#EF3E42"
    },
    d: "M37,50.4L7.6,31.1l44.3,9l-1.9,15L16.4,93.2"
  }), React.createElement("path", {
    style: {
      "fill": "#FFD520"
    },
    d: "M28,84.3l29.3-18.6l39.5,32.1L56.1,77.7"
  })), React.createElement("g", {
    style: {
      "fill": "white"
    }
  }, _ref2, _ref3, _ref4));
};

export default __webpack_public_path__ + "static/media/ACC.7623b150.svg";
export { SvgComponent as ReactComponent };